import React, { useState, useEffect } from 'react';
import { Download, FileText } from 'lucide-react';
import { templateService } from '../services/api';

function Templates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await templateService.getAll();
        if (response.data) {
          setTemplates(response.data);
        }
      } catch (error) {
        console.error('Error fetching templates:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">قالب و الگو</h1>
          <p className="text-xl text-blue-100">دانلود قالب‌های مورد نیاز برای ارسال مقاله</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {templates.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {templates.map((template, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition flex flex-col">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <FileText className="w-6 h-6 text-blue-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900">{template.name}</h3>
                    <p className="text-sm text-gray-500">{template.format}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm mb-4 flex-1">{template.description}</p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <span className="text-xs text-gray-500">{template.size}</span>
                  {template.downloadUrl ? (
                    <a
                      href={template.downloadUrl}
                      download
                      className="flex items-center gap-2 text-blue-700 hover:text-blue-900 font-semibold text-sm"
                    >
                      <Download size={16} />
                      دانلود
                    </a>
                  ) : (
                    <span className="text-xs text-gray-400">بدون لینک</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Templates;
